import React from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router";

import {
    Card,
    CardActionArea,
    CardContent,
    Typography,
    CardHeader,
    Tooltip,
    Box,
    FormControl,
    FormHelperText,
} from "@mui/material";
import SearchField from "../../../Common/SearchField";
import TMSAvatar from "../TMSAvatar";

function LibraryCard() {
    const history = useHistory();
    return (
        <Card className="card">
            <CardActionArea
                component={Link}
                to={"/tms/library"}
                centerRipple={true}
            >
                <CardHeader
                    disableTypography={true}
                    avatar={
                        <Tooltip title="View library" arrow>
                            <TMSAvatar type="library" />
                        </Tooltip>
                    }
                    title={
                        <Typography
                            component="h2"
                            className="card-header-title"
                        >
                            Library
                        </Typography>
                    }
                    subheader={
                        <Typography
                            component="span"
                            className="card-header-subtitle"
                        >
                            browse courses
                        </Typography>
                    }
                />
            </CardActionArea>
            <CardContent>
                <Box className="card-content">
                    <FormControl fullWidth={true} margin="normal">
                        <SearchField
                            onSearch={(searchString) =>
                                history.replace(
                                    `/tms/courses?q=${searchString}`
                                )
                            }
                            placeholder="Search"
                            label="search courses"
                        />
                        <FormHelperText id="my-helper-text">
                            Search courses by title or code.
                        </FormHelperText>
                    </FormControl>
                </Box>
            </CardContent>
        </Card>
    );
}

export default LibraryCard;
